import { render, staticRenderFns } from "./LastCustomerRegister.vue?vue&type=template&id=3e2fa288&"
import script from "./LastCustomerRegister.vue?vue&type=script&lang=ts&"
export * from "./LastCustomerRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports